import React from "react";
import PolicyPage from "@/components/PolicyPage";

export default function GizlilikPolitikasi() {
  return (
    <PolicyPage
      slug="gizlilik-politikasi"
      title="Gizlilik Politikası"
      intro="Abonelik İptal, kullanıcılarının gizliliğini korumayı önemser. Bu politika hangi verileri, hangi amaçla işlediğimizi ve nasıl güvence altına aldığımızı açıklar."
      metaTitle="Gizlilik Politikası | Abonelik İptal"
      metaDescription="Abonelik İptal'in kullanıcı verilerini nasıl işlediği, güvenlik yaklaşımı ve kullanıcı hakları hakkında bilgi edinin."
      sections={[
        {
          heading: "Kim olduğumuz",
          body: [
            "Abonelik İptal, Türkiye tüketicilerine iptal, iade ve itiraz süreçlerinde yardımcı olan bir yardımcı platformdur. Resmi bir kurum değildir ve hukuki danışmanlık vermez.",
          ],
        },
        {
          heading: "İstemediğimiz bilgiler",
          bullets: [
            "e-Devlet şifreniz istenmez — Abonelik İptal e-Devlet'e bağlanmaz.",
            "Banka veya kart şifreniz istenmez — Abonelik İptal banka sistemlerine bağlanmaz.",
            "Fiziksel kimlik numarası veya kart bilgisi bu platform üzerinden toplanmaz.",
          ],
        },
        {
          heading: "İşlediğimiz veriler",
          bullets: [
            "Seçtiğiniz sorun tipi, kurum ve problem detayı (başvurunuzu hazırlamak için).",
            "Kendi yazdığınız kısa açıklama metni (kişiselleştirilmiş çıktı üretmek için).",
            "Yükleme adımında verdiğiniz dosya adı ve boyutu (MVP'de dosya içeriği kalıcı olarak saklanmaz).",
            "Sitenin teknik çalışması ve performans ölçümü için standart günlük bilgileri.",
          ],
        },
        {
          heading: "Belgeler ve MVP notu",
          body: [
            "MVP sürümünde yüklediğiniz belgelerin içeriği kalıcı bir dosya depolamada saklanmaz; yalnızca dosya adı ve boyutu gibi metadata bilgisi hazırlık amacıyla kısa süreli kullanılabilir. Belge içeriği hiçbir üçüncü tarafla paylaşılmaz.",
          ],
        },
        {
          heading: "Analitik ve çerezler",
          body: [
            "Site kullanımını anlamak ve performansı iyileştirmek için ileride analitik araçlar entegre edilebilir. Aktif olduğunda çerez politikamız çerçevesinde şeffaflıkla belirtilir.",
          ],
        },
        {
          heading: "Verilerinizin paylaşımı",
          body: [
            "Verileriniz reklam veya pazarlama amaçlı üçüncü taraflarla paylaşılmaz. Yalnızca hizmetin sağlanması için gerekli teknik altyapı sağlayıcıları (barındırma, e-posta) veri işleyen sıfatıyla erişebilir.",
          ],
        },
        {
          heading: "Haklarınız ve iletişim",
          body: [
            "KVKK kapsamındaki haklarınızı kullanmak veya bu politikayla ilgili sorularınız için destek@abonelikiptal.com adresine ulaşabilirsiniz. Detay için KVKK Aydınlatma Metni sayfamıza bakabilirsiniz.",
          ],
        },
      ]}
    />
  );
}
